import React, { useState, useEffect } from 'react';
import axios from "axios";
import Header from '../Header';
import Footer from '../Footer';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import CommonDatePicker from '../datepicker/CommonDatePicker';
import 'rsuite/dist/rsuite.min.css';
import 'datatables.net';
import { API_URL, BASE_URL } from '../Config';
import config from "../common/Config";
import * as XLSX from 'xlsx';
import Select from 'react-select';

const MisProductReport = () => {
    const [draw, setDraw] = useState(1);
    const [start, setStart] = useState(0);
    const [length, setLength] = useState(50);
    const now = new Date();
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    const [dates, setDates] = useState([startOfMonth, endOfMonth]);
    const [reportrange, setReportrange] = useState('');
    const [reportAmount, setReportAmount] = useState('');
    //const [pageOption, setPageOption] = useState('');
    const [pageCndDataOptions, setPageCndDataOptions] = useState([]);
    const [pageCndData, setPageCndData] = useState('');
    const [showProductWise, setShowProductWise] = useState(false);
    const [productWiseOptions, setProductWiseOptions] = useState([]);
    const [productWise, setProductWise] = useState('');
    const [productInputValue, setProductInputValue] = useState('');
    const [productFilteredOptions, setProductFilteredOptions] = useState([]);
    const [productValue, setProductValue] = useState(null);
    const [productReport, setProductReport] = useState([]);
    const [showpickListOption, setShowpickListOption] = useState(false);
    const [pickListOptions, setPickListOptions] = useState([]);
    const [pickListWise, setPickListWise] = useState('');
    const [showSalesRepOption, setShowSalesRepOption] = useState(false);
    const [salesRepOptions, setSalesRepOptions] = useState([]);
    const [salesRepWise, setSalesRepWise] = useState('');
    const accessToken = localStorage.getItem('accessToken');

    const handleDateChange = (value) => {
        setDates(value);
        let startDate = format(value[0], 'dd-MM-yyyy');
        let endDate = format(value[1], 'dd-MM-yyyy');
        setReportrange(startDate + ' - ' + endDate);
    };
    const handleChangeOption = (event) => {
        const value = event.target.value;
        setPageCndData(value);
    };
    const productHandleInputChange = (inputValue) => {
        setProductInputValue(inputValue);
        const newFilteredOptions = productWiseOptions.filter(option =>
            option.label.toLowerCase().includes(inputValue.toLowerCase()) ||
            (option.code && option.code.toLowerCase().includes(inputValue.toLowerCase()))
        );
        setProductFilteredOptions(newFilteredOptions);
    };
    const productHandleChange = (selectedOption) => {
        if (selectedOption) {
            setProductValue(selectedOption);
            setProductWise(selectedOption.value);
        } else {
            setProductValue(null);
            setProductWise('');
        }
    };
    const handleChangePickOption = (event) => {
        const value = event.target.value;
        setPickListWise(value);
    };

    const handleChangeSRapOption = (event) => {
        const value = event.target.value;
        setSalesRepWise(value);
    };

    const searchFormData = () => {
        // let startDate = format(dates[0], 'dd-MM-yyyy');
        // let endDate = format(dates[1], 'dd-MM-yyyy');
        // setReportrange(startDate + ' - ' + endDate);
        fetchProductWiseData();
    };

    // useEffect(() => {
    // 	if (reportrange) {
    // 		fetchProductWiseData();
    // 	}
    // }, [reportrange]);

    const fetchProductOptions = async () => {
        let startDate = format(dates[0], 'MM/dd/yyyy');
        let endDate = format(dates[1], 'MM/dd/yyyy');
        let pdtrange = startDate + ' - ' + endDate;
        const pdtData = new FormData();
        pdtData.append('reportrange', pdtrange);

        const apiPdtOptionUrl = `${config.API_URL}/purchases/getProducts`;
        try {
            const response = await fetch(apiPdtOptionUrl, {
                method: 'POST',
                headers: {
                    authorization: `Bearer ${accessToken}`,
                },
                body: pdtData,
            });
            const data = await response.json();
            const formattedOptions = data.products.map(item => ({
                label: `${item.name} (${item.code})`,
                value: item.id,
                code: item.code,
                name: item.name
            }));

            setProductWiseOptions(formattedOptions);
        } catch (error) {
            console.error('api fail Error fetching Not Order Report:', error);
        }
    };

    const fetchPickListOptions = async () => {
        let startDate = format(dates[0], 'MM/dd/yyyy');
        let endDate = format(dates[1], 'MM/dd/yyyy');
        let pdtrange = startDate + ' - ' + endDate;
        const pdtData = new FormData();
        pdtData.append('reportrange', pdtrange);

        const apiPickListUrl = `${config.API_URL}/getpicklist`;
        try {
            const response = await fetch(apiPickListUrl, {
                method: 'POST',
                headers: {
                    // 'Content-Type': 'application/json',
                    authorization: `Bearer ${accessToken}`,
                },
                body: pdtData,
            });

            const data = await response.json();
            const formattedOptions = data.picklist.map(item => ({
                key: `${item.picklist_number}`,
                value: item.picklist_number,
            }));
            setPickListOptions(formattedOptions);
        } catch (error) {
            console.error('api fail Error fetching Not Order Report:', error);
        }
    };

    const fetchSalesRepOptions = async () => {
        let startDate = format(dates[0], 'MM/dd/yyyy');
        let endDate = format(dates[1], 'MM/dd/yyyy');
        let pdtrange = startDate + ' - ' + endDate;
        const pdtData = new FormData();
        pdtData.append('reportrange', pdtrange);

        //const apiPickListUrl = `${config.API_URL}/getpicklist`;
        const apiPickListUrl = `${config.API_URL}/getSalesRep`;
        try {
            const response = await fetch(apiPickListUrl, {
                method: 'POST',
                headers: {
                    // 'Content-Type': 'application/json',
                    authorization: `Bearer ${accessToken}`,
                },
                body: pdtData,
            });

            const data = await response.json();
            const formattedOptions = data.data.map(item => ({
                key: `${item.first_name} ${item.last_name}`,
                value: item.id,
            }));
            setSalesRepOptions(formattedOptions);
        } catch (error) {
            console.error('api fail Error fetching Not Order Report:', error);
        }
    };

    const fetchProductWiseData = async () => {
        // let startDate = format(dates[0], 'MM-dd-yyyy');
        // let endDate = format(dates[1], 'MM-dd-yyyy');
        // let pdtrange = startDate + ' - ' + endDate;
        const pdtData = new FormData();
        let ptype = pageCndData;

        // alert(ptype);
        if (ptype === 'order_wise') {
            setProductWise('');
            setPickListWise('');
            setSalesRepWise('');
        }
        else if (ptype === 'pick_list_wise') {
            setProductWise('');
            setSalesRepWise('');
        }
        else if (ptype === 'sales_rep_wise') {
            setPickListWise('');
            setProductWise('');
        }
        else if (ptype === 'reject_order_wise') {
            setProductWise('');
            setPickListWise('');
            setSalesRepWise('');
        }
        else if (ptype === 'undeliver_order_wise') {
            setProductWise('');
            setPickListWise('');
            setSalesRepWise('');
        }
        else if (ptype === 'is_deleted_product_wise') {
            setProductWise('');
            setPickListWise('');
            setSalesRepWise('');
        }

        // console.log(ptype);
        pdtData.append('draw', draw);
        pdtData.append('start', start);
        pdtData.append('length', length);
        pdtData.append('reportrange', reportrange);
        pdtData.append('type', ptype ? ptype : 'product_wise');
        pdtData.append('product_id', productWise);
        pdtData.append('pick_list', pickListWise);
        pdtData.append('sales_rep_id', salesRepWise);

        const apiMissingProductUrl = `${config.API_URL}/get_Mis_Product_report`;

        try {
            const response = await fetch(apiMissingProductUrl, {
                method: 'POST',
                headers: {
                    // 'Content-Type': 'application/json',
                    authorization: `Bearer ${accessToken}`,
                },
                body: pdtData,
            });

            if (!response.ok) {
                throw new Error('Failed to fetch Not Order Report');
            }
            const data = await response.json();
            data.type = ptype ? ptype : 'product_wise';
            console.log(ptype);
            setProductReport(data);
            if (ptype === 'reject_order_wise') {
                setReportAmount(data.order_total + ' | Reject Amt : ' + data.missing_total);
            } else
                if (ptype === 'undeliver_order_wise') {
                    setReportAmount(data.order_total + ' | Undeliver Amt : ' + data.missing_total);
                } else
                    if (ptype === 'is_deleted_product_wise') {
                        setReportAmount(data.order_total + ' | Deleted Amt : ' + data.missing_total);
                    }
                    else {
                        setReportAmount(data.order_total + ' | Missing Amt : ' + data.missing_total);
                    }
            //setReportAmount(data.order_total + ' | Missing Amt : ' + data.missing_total);
        } catch (error) {
            console.error('api fail Error fetching Not Order Report:', error);
        }
    };
    const exportToExcel = async () => {
        // Remove unused searchValue
        // Build FormData with current filters
        const formData = new FormData();
        let ptype = pageCndData;
        formData.append('draw', draw);
        formData.append('start', start);
        formData.append('length', length);
        formData.append('reportrange', reportrange);
        formData.append('type', ptype ? ptype : 'product_wise');
        formData.append('product_id', productWise);
        formData.append('pick_list', pickListWise);
        formData.append('sales_rep_id', salesRepWise);

        const apiMissingProductUrl = `${config.API_URL}/get_missing_order_report`;

        try {
            const response = await fetch(apiMissingProductUrl, {
                method: 'POST',
                headers: {
                    authorization: `Bearer ${accessToken}`,
                },
                body: formData,
            });

            if (!response.ok) {
                throw new Error('Failed to fetch Products');
            }

            const data = await response.json();
            // You can adjust the export columns as needed
            const exportData = data.data.map(product => ({
                "Product Code": product.product_code || '',
                "Product Name": product.product_name || '',
                "Order Type": product.order_type || '',
                "Order Qty": product.order_qty || '',
                "Accept Qty": product.accept_qty || '',
                "Picking Qty": product.picking_qty || '',
                "Missing Qty": product.cross_total || '',
                "Deliver Qty": product.deliver_qty || '',
                "Undeliver Qty": product.undeliver_qty || '',
                "Reject/Deleted Qty": product.reject_deleted || ''
            }));

            const ws = XLSX.utils.json_to_sheet(exportData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'MisProductReport');

            // Filename with timestamp
            const now = new Date();
            const formattedDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
            const formattedTime = `${String(now.getHours()).padStart(2, '0')}-${String(now.getMinutes()).padStart(2, '0')}-${String(now.getSeconds()).padStart(2, '0')}`;
            const filename = `cross-off-report-${formattedDate}-${formattedTime}.xlsx`;

            XLSX.writeFile(wb, filename);
        } catch (error) {
            console.error("Error exporting to Excel:", error);
        }
    };
    useEffect(() => {
        if (accessToken === null) {
            window.location.href = `${config.BASE_URL}/login`;
            return;
        }
        const options = [
            { value: 'product_wise', key: 'Product Wise' },
            { value: 'order_wise', key: 'Order Wise' },
            { value: 'pick_list_wise', key: 'Pick List Wise' },
            // { value: 'sales_rep_wise', key: 'Sales Rep Wise' },
            // { value: 'reject_order_wise', key: 'Reject Order Product Wise' },
            // { value: 'undeliver_order_wise', key: 'Undeliver Product Wise' },
            // { value: 'is_deleted_product_wise', key: 'Deleted Product Wise' }
        ];

        setPageCndDataOptions(options);
        fetchProductOptions();
        fetchProductWiseData();
        fetchPickListOptions();
        fetchSalesRepOptions();
    }, []);


    useEffect(() => {
        if (pageCndData) {
            fetchProductWiseData();
        }
    }, [pageCndData]);


    const getColumnsForType = (type) => {
        switch (type) {
            case 'product_wise':
                return [
                    { data: null },
                    { data: 'product_name' },
                    { data: 'order_type' },
                    { data: 'order_qty' },
                    { data: 'accept_qty' },
                    // { data: 'picking_qty' },
                    { data: 'cross_total' },
                    { data: 'deliver_qty' },

                    { data: 'undeliver_qty' },
                    { data: 'reject_deleted' },

                ];

            case 'reject_order_wise':
                return [
                    { data: null },
                    { data: 'product_name' },
                    { data: 'order_type' },
                    { data: 'total_items' },
                    {
                        data: null,
                        render: function (data, type, row) {
                            return `<span>${parseFloat(row.reject_total).toFixed(2)}</span>`;
                        }
                    }
                ];
            case 'undeliver_order_wise':
                return [
                    { data: null },
                    { data: 'product_name' },
                    { data: 'order_type' },
                    { data: 'total_items' },
                    {
                        data: null,
                        render: function (data, type, row) {
                            return `<span>${parseFloat(row.undeliver_total).toFixed(2)}</span>`;
                        }
                    }
                ];
            case 'is_deleted_product_wise':
                return [
                    { data: null },
                    { data: 'product_name' },
                    { data: 'order_type' },
                    { data: 'total_items' },
                    {
                        data: null,
                        render: function (data, type, row) {
                            return `<span>${parseFloat(row.deleted_total).toFixed(2)}</span>`;
                        }
                    }
                ];



            case 'order_wise':
                return [
                    { data: null },
                    { data: 'date' },
                    { data: 'reference_no' },
                    { data: 'customer' },
                    {
                        data: null,
                        render: function (data, type, row) {
                            return `<span>${parseFloat(row.order_total).toFixed(2)}</span>`;
                        }
                    },
                    { data: 'missing_total' },
                    { data: 'return_total' },
                    { data: 'deliverd_total' },
                    { data: 'return_total' },
                    { data: 'sale_status' }
                ];
            case 'pick_list_wise':
                return [
                    { data: null },
                    { data: 'date' },
                    { data: 'reference_no' },
                    { data: 'customer' },
                    {
                        data: null,
                        render: function (data, type, row) {
                            return `<span>${parseFloat(row.order_total).toFixed(2)}</span>`;
                        }
                    },
                    { data: 'missing_total' },
                    { data: 'return_total' },
                    { data: 'deliverd_total' },
                    { data: 'return_total' },
                    { data: 'sale_status' }
                ];
            case 'sales_rep_wise':
                return [
                    { data: null },
                    { data: 'date' },
                    { data: 'reference_no' },
                    { data: 'customer' },
                    {
                        data: null,
                        render: function (data, type, row) {
                            return `<span>${parseFloat(row.order_total).toFixed(2)}</span>`;
                        }
                    },
                    { data: 'missing_total' },
                    { data: 'return_total' },
                    { data: 'deliverd_total' },
                    { data: 'return_total' },
                    { data: 'sale_status' }
                ];
            default:
                return [];
        }
    };

    useEffect(() => {

        const clearTable = () => {
            if ($.fn.DataTable.isDataTable('#CrossReport')) {
                $('#CrossReport').DataTable().destroy();
                $('#CrossReport').empty(); // Clear existing data and headers
            }
        };

        const initializeDataTable = () => {
            const columns = getColumnsForType(productReport.type);
            const headers = getHeadersForType(productReport.type);
            clearTable();

            $('#CrossReport thead').html(headers.join(''));
            $('#CrossReport tfoot').remove();

            const footers = getFootersForType(productReport.type);
            // Append tfoot BEFORE DataTable initialization so DataTables can detect it
            $('#CrossReport').append(footers.join(''));

            const table = $('#CrossReport').DataTable({
                pageLength: 50,
                paging: true,
                lengthMenu: [10, 20, 50],
                searching: true,
                ordering: true,
                info: true,
                responsive: true,
                autoWidth: false,
                language: {
                    paginate: {
                        first: 'First',
                        last: 'Last',
                        next: 'Next',
                        previous: 'Previous',
                    },
                    search: 'Search:',
                },
                data: productReport.data,
                columns: columns,
                footerCallback: function (row, data, start, end, display) {
                    if (productReport.type === "product_wise") {
                        $('#footer_order_qty').html(productReport.order_qty || '');
                        $('#footer_accept_qty').html(productReport.accept_qty || '');
                        // $('#footer_picking_qty').html(productReport.picking_qty || '');
                        $('#footer_missing_qty').html(productReport.cross_total || '');
                        $('#footer_deliver_qty').html(productReport.deliver_qty || '');

                        $('#footer_reject_deleted_qty').html(productReport.reject_deleted || '');
                        $('#footer_undeliver_qty').html(productReport.undeliver_qty || '');
                    }

                    // Add similar logic for other report types if needed
                },
                drawCallback: function (settings) {
                    var api = this.api();
                    var startIndex = api.page.info().start;
                    api.column(0, { page: 'current' }).nodes().each(function (cell, i) {
                        cell.innerHTML = startIndex + i + 1;
                    });
                }
            });

            // Update the table header
            $('#CrossReport thead').html(headers.join(''));
            // const footers = getFootersForType(productReport.type);
            // $('#CrossReport').append(footers.join(''));
        };

        if (productReport.type === "product_wise" || productReport.type === "order_wise" || productReport.type === "pick_list_wise" || productReport.type === "sales_rep_wise" || productReport.type === "reject_order_wise" || productReport.type === "undeliver_order_wise" || productReport.type === "is_deleted_product_wise") {
            initializeDataTable();
        }

        // Cleanup DataTable on component unmount or when `productReport` changes
        return () => {
            clearTable();
        };
    }, [productReport]);


    const getHeadersForType = (type) => {
        switch (type) {
            case 'product_wise':
                return ["<tr>",
                    "<th>#</th>",
                    "<th>Product (Code)</th>",
                    "<th>Order Type</th>",
                    "<th>Order Qty</th>",
                    "<th>Accept Qty</th>",
                    // "<th>Picking Qty</th>",
                    "<th>Missing Qty</th>",
                    "<th>Deliver Qty</th>",
                    "<th>Undeliver Qty</th>",
                    "<th>Reject / Deleted Qty</th>",
                    "</tr>"
                ];
            case 'order_wise':
                return ["<tr>",
                    "<th>#</th>",
                    "<th>Order Date</th>",
                    "<th>Order Id</th>",
                    "<th>Customers (A/c No)</th>",
                    "<th>Order Amt</th>",
                    "<th>Missing Qty</th>",
                    "<th>Missing Amt</th>",
                    "<th>Delivered Amt</th>",
                    "<th>Return Amt</th>",
                    "<th>Status</th>",
                    "</tr>"
                ];
            case 'pick_list_wise':
                return ["<tr>",
                    "<th>#</th>",
                    "<th>Order Date</th>",
                    "<th>Order Id</th>",
                    "<th>Customers (A/c No)</th>",
                    "<th>Order Amt</th>",
                    "<th>Missing Qty</th>",
                    "<th>Missing Amt</th>",
                    "<th>Delivered Amt</th>",
                    "<th>Return Amt</th>",
                    "<th>Status</th>",
                    "</tr>"
                ];
            case 'sales_rep_wise':
                return ["<tr>",
                    "<th>#</th>",
                    "<th>Order Date</th>",
                    "<th>Order Id</th>",
                    "<th>Customers (A/c No)</th>",
                    "<th>Order Amt</th>",
                    "<th>Missing Qty</th>",
                    "<th>Missing Amt</th>",
                    "<th>Delivered Amt</th>",
                    "<th>Return Amt</th>",
                    "<th>Status</th>",
                    "</tr>"
                ];
            case 'reject_order_wise':
                return ["<tr>",
                    "<th>#</th>",
                    "<th>Product (Code)</th>",
                    "<th>Order Type</th>",
                    "<th>Qty</th>",
                    "<th>Reject Amt</th>",
                    "</tr>"
                ];
            case 'undeliver_order_wise':
                return ["<tr>",
                    "<th>#</th>",
                    "<th>Product (Code)</th>",
                    "<th>Order Type</th>",
                    "<th>Qty</th>",
                    "<th>Undeliver Amt</th>",
                    "</tr>"
                ];
            case 'is_deleted_product_wise':
                return ["<tr>",
                    "<th>#</th>",
                    "<th>Product (Code)</th>",
                    "<th>Order Type</th>",
                    "<th>Qty</th>",
                    "<th>deleted Amt</th>",
                    "</tr>"
                ];
            default:
                return [];
        }
    };

    const getFootersForType = (type) => {
        switch (type) {
            case 'product_wise':
                return ["<tfoot><tr>",
                    "<th colspan='3' style='text-align:right'>Totals:</th>",
                    "<th id='footer_order_qty'></th>",
                    "<th id='footer_accept_qty'></th>",
                    // "<th id='footer_picking_qty'></th>",
                    "<th id='footer_missing_qty'></th>",
                    "<th id='footer_deliver_qty'></th>",
                    "<th id='footer_undeliver_qty'></th>",
                    "<th id='footer_reject_deleted_qty'></th>",
                    "</tr></tfoot>"
                ];
            // ...add other cases as needed...
            default:
                return [];
        }
    };


    useEffect(() => {
        setShowProductWise(false);
        setShowpickListOption(false);
        setShowSalesRepOption(false);

        switch (pageCndData) {
            case "product_wise":
                setShowProductWise(true);
                break;
            case "pick_list_wise":
                setShowpickListOption(true);
                break;
            case "sales_rep_wise":
                setShowSalesRepOption(true);
                console.log("show sales_rep_wise");
                break;
            default:
                break;
        }
        if (pageCndData == "") {
            setShowProductWise(true);
        }

        // console.log(pageCndData);
    }, [pageCndData]);


    return (
        <div>
            <Header />
            <div className="breadcrumbs">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-lg-12 col-sm-12">
                            <Link to="/Dashboard"><i className="fa fa-home"></i></Link>
                            <Link to="/reports/mis_product_report">Reports</Link>
                            <Link to="/reports/mis_product_report">Mis Product wise report</Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="main-container">
                <div className="container-fluid">
                    <div className="row">


                        <div className="date-range-picker col-md-3 col-lg-3 col-sm-12" style={{ float: 'left' }}>
                            <div class="row mb-3 padd-0">
                                <label class="col-sm-4" style={{ marginBottom: '5px' }} ><b> Date</b></label>
                                <div class="col-sm-8">
                                    <CommonDatePicker
                                        value={dates}
                                        showOneCalendar
                                        // placeholder="DD/MM/YYYY - DD/MM/YYYY"
                                        onChange={handleDateChange}
                                        format="dd/MM/yyyy"
                                        character=" - "
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* <div className="date-range-picker col-md-3 col-lg-3 col-sm-12" style={{ float: 'left' }}>
                            <div class="row mb-3 padd-0">
                                <label class="col-sm-4" style={{ marginBottom: '5px' }} ><b>Select Type</b></label>
                                <div class="col-sm-8">
                                <select value={pageCndData} onChange={handleChangeOption} className="form-control selectinput" name="" id="" >
                                    {pageCndDataOptions.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.key}
                                        </option>
                                    ))}
                                </select>
                                </div>
                            </div>
                        </div> */}

                        {showProductWise && (
                            <div className="date-range-picker col-md-3 col-lg-3 col-sm-12" style={{ float: 'left' }}>
                                <div class="row mb-3 padd-0">
                                    <label class="col-sm-4" style={{ marginBottom: '5px' }} ><b> Product</b></label>
                                    <div class="col-sm-8">
                                        <Select
                                            className='abovedd'
                                            isClearable
                                            onInputChange={productHandleInputChange}
                                            onChange={productHandleChange}
                                            options={productFilteredOptions}
                                            placeholder="Select Product"
                                            value={productValue}
                                            styles={{ marginBottom: '15px' }}
                                            formatOptionLabel={option => (
                                                <div>
                                                  <span>{option.name}</span>
                                                  <span style={{ color: '#888', marginLeft: 8 }}>({option.code})</span>
                                                </div>
                                              )}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}


                        {showpickListOption && (
                            <div className="date-range-picker col-md-3 col-lg-3 col-sm-12" style={{ float: 'left' }}>
                                <div class="row mb-3 padd-0">
                                    <label class="col-sm-4" style={{ marginBottom: '5px' }} ><b>&nbsp;</b></label>
                                    <div class="col-sm-8">
                                        <select value={pickListWise} onChange={handleChangePickOption} className="form-control selectinput" name="" id="" >
                                            <option value="">Select Pick List</option>
                                            {pickListOptions.map(option => (
                                                <option key={option.value} value={option.value}>
                                                    {option.key}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        )}

                        {showSalesRepOption && (
                            <div className="date-range-picker col-md-3 col-lg-3 col-sm-12" style={{ float: 'left' }}>
                                <div class="row mb-3 padd-0">
                                    <label class="col-sm-4" style={{ marginBottom: '5px' }} ><b>&nbsp;</b></label>
                                    <div class="col-sm-8">
                                        <select value={salesRepWise} onChange={handleChangeSRapOption} className="form-control selectinput" name="" id="" >
                                            <option value="">Select Sales Rap</option>
                                            {salesRepOptions.map(option => (
                                                <option key={option.value} value={option.value}>
                                                    {option.key}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        )}


                        <div className="col-md-2 col-lg-2 col-sm-6" style={{ float: 'left' }} >
                            <button type="button" onClick={searchFormData} className="acceptbtn" style={{ float: 'left' }}>Submit</button>
                            <button className="create-catalogue-btn" onClick={exportToExcel} style={{ textTransform: 'capitalize' }}>
                                Export
                            </button>
                        </div>



                    </div>

                    <div className="total-manifests-area dashboard">
                        {/* <p className="text-center" style={{ border: 'none', padding: '0px 0 5px 0', margin: '0px 0 5px 0', borderBottom: '1px solid #d0cece' }} ><b>Order Amt : {reportAmount} </b></p> */}

                        <div className="verical-scrl-wrapper common-table autoheight-table crossofreport" id="style-3">
                            <table className="table table-bordered resizable" id="CrossReport">
                                <thead>
                                </thead>
                                <tbody>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default MisProductReport;